export const formatCurrency = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}).format;



// WEBPACK FOOTER //
// ./src/util/Masks/formatCurrency.ts